import { Component, Input } from '@angular/core';

export enum LozengeType {
  Success = 'aui-lozenge-success',
  Removed = 'aui-lozenge-removed',
  Moved = 'aui-lozenge-moved',
  New = 'aui-lozenge-new',
}

@Component({
  selector: 'app-lozenge',
  // eslint-disable-next-line @typescript-eslint/quotes
  template: `<span class="aui-lozenge {{ subtle ? 'aui-lozenge-subtle' : '' }} {{ type }}">{{ label }}</span>`,
})
export class LozengeComponent {
  @Input() type = '';
  @Input() label: string | null = '';
  @Input() subtle = false;
}
